<div class="home">
  <div class="home__content">
    <app-header />

    <div class="home__hero-container">
      <section class="home__hero" aria-labelledby="home-title">
        <h1 id="home-title" class="home__title">Bienvenue chez Constructel</h1>
        <p class="home__subtitle">Que souhaitez-vous faire ?</p>
      </section>
  
      <section class="home__cards" aria-label="Que souhaitez-vous faire ?">
        <div class="home__cards-row">
          @for (option of identificationOptions; track option.variant) {
            @if (option.variant !== 'documents') {
              <app-identification-card
                [variant]="option.variant"
                [title]="option.title"
                [subtitle]="option.subtitle"
                [illustrationSrc]="option.illustrationSrc"
                [illustrationAlt]="option.illustrationAlt"
                (pressed)="onCardPressed(option.variant)"
              />
            }
          }
        </div>
  
        @if (showDocuments()) {
          @for (option of identificationOptions; track option.variant) {
            @if (option.variant === 'documents') {
              <app-identification-card
                [variant]="option.variant"
                [title]="option.title"
                [subtitle]="option.subtitle"
                [illustrationSrc]="option.illustrationSrc"
                [illustrationAlt]="option.illustrationAlt"
                (pressed)="onCardPressed(option.variant)"
              />
            }
          }
        }
      </section>
    </div>
    
    <app-footer />
  </div>
</div>

